import isNil from 'lodash/isNil';

import { IPersonalDataFile } from '../types/file';

export interface IPersonalDataFileResponse {
    id?: string;
    name?: string;                          // Электронная копия документа
}

export const personalDataFileMapping = (response?: IPersonalDataFileResponse[]): IPersonalDataFile[] =>
    response?.reduce((files: IPersonalDataFile[], file) => {
        if (!isNil(file.id) && file.name) {
            files.push({ id: file.id, name: file.name });
        }
        return files;
    }, []) ?? [];
